export default __webpack_public_path__ + "static/reset-password-8307a5973206c4e3b3ebf21d55443c39.png";